import React, { useEffect, useRef } from "react";
import { Button, Icon } from "semantic-ui-react";
import { saveAs } from "file-saver";
import { useLanguage } from "../../../../contexts";
import { motor } from "../engine";
import "../common/common.scss";
import "../MethodologyGuide/MethodologyGuide.scss";
import "./GuideScreen.scss";

const CSS_DESCARGA = "body{font-family:Arial,Helvetica,sans-serif;color:#1a1c42;max-width:900px;margin:24px auto;padding:0 18px;line-height:1.55;font-size:14px}"
  + "table{border-collapse:collapse;width:100%;margin:10px 0;font-size:12.5px}th,td{border:1px solid #c9d3e0;padding:6px 8px;text-align:left;vertical-align:top}"
  + "th{background:#003872;color:#fff}h1,h4{color:#003872}a{color:#003872}";

// Guía paso a paso (hoja 01, fila 53): primera pestaña del menú, descargable en HTML. El texto es el del paquete de
// Sustemia (limpio); sus enlaces llevan a la pestaña correspondiente.
export function GuideScreen({ onIr }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const { guia } = motor.textos;
  const cuerpo = useRef(null);

  // los enlaces a pestañas no tienen href: se hacen accesibles con teclado
  useEffect(() => {
    (cuerpo.current ? cuerpo.current.querySelectorAll("a[data-goto]") : []).forEach((a) => {
      a.setAttribute("role", "link");
      a.setAttribute("tabindex", "0");
    });
  }, []);

  const tecla = (e) => {
    if (e.key === "Enter" && e.target.matches && e.target.matches("a[data-goto]")) clic(e);
  };
  const clic = (e) => {
    const a = e.target.closest("a[data-goto]");
    if (!a) return;
    e.preventDefault();
    onIr?.(a.getAttribute("data-goto"));
  };
  const descargar = () => {
    const html = `<!doctype html><html lang="es"><head><meta charset="utf-8"><title>${guia.titulo}</title><style>${CSS_DESCARGA}</style></head>`
      + `<body><h1>${guia.titulo}</h1>${guia.html.replace(/<a data-goto="[a-z]+">([\s\S]*?)<\/a>/g, "<strong>$1</strong>")}</body></html>`;
    saveAs(new Blob([html], { type: "text/html;charset=utf-8" }), "Sustemia_Guia_paso_a_paso.html");
  };

  return (
    <div className="ep-screen ep-guia">
      <header className="ep-section__header">
        <h3 className="ep-screen__title">{guia.titulo}</h3>
        <Button type="button" basic size="small" onClick={descargar}><Icon name="download" /> {t("energy_performance_guide_download")}</Button>
      </header>
      {/* contenido fijo del paquete: solo etiquetas de contenido, sin atributos salvo data-goto (validado al extraer) */}
      <div ref={cuerpo} className="ep-method__card ep-guia__body" onClick={clic} onKeyDown={tecla} dangerouslySetInnerHTML={{ __html: guia.html }} />
    </div>
  );
}
